<template>
  <section class="about">
    <div class="container">
      <div class="about-content">
        <div class="about-text">
          <h2 class="about-title">About Keramicke Kondenzatory a.s.</h2>
          <p class="about-description">
            With over 30 years of experience in ceramic capacitor manufacturing, 
            Keramicke Kondenzatory a.s. has established itself as a trusted supplier of high-quality 
            passive components for demanding applications worldwide.
          </p>
          <p>
            Our team of materials scientists, engineers, and quality specialists work 
            together to deliver products that meet the highest standards of performance 
            and reliability. We believe in continuous innovation and investing in 
            advanced manufacturing technologies to serve our customers better.
          </p>
          
          <div class="about-highlights">
            <div class="highlight">
              <h4>Our Mission</h4>
              <p>
                To provide industry-leading ceramic capacitors that enable technological 
                advancement through superior quality, innovation, and customer partnership.
              </p>
            </div>
            <div class="highlight">
              <h4>Our Commitment</h4>
              <p>
                We combine cutting-edge materials science with precision manufacturing, 
                ensuring every component meets exacting specifications for reliability and performance.
              </p>
            </div>
          </div>
          
          <RouterLink to="/team" class="btn btn-primary">
            Meet Our Team
          </RouterLink>
        </div>
        
        <div class="about-visual">
          <div class="visual-grid">
            <div class="visual-item visual-large">
              <div class="placeholder-image">
                <span class="visual-icon">⚡</span>
                <p>Precision Manufacturing</p>
              </div>
            </div>
            <div class="visual-item">
              <div class="placeholder-image">
                <span class="visual-icon">🔬</span>
                <p>Advanced Testing</p>
              </div>
            </div>
            <div class="visual-item">
              <div class="placeholder-image">
                <span class="visual-icon">✓</span>
                <p>Quality Assurance</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script setup lang="ts">
import { RouterLink } from 'vue-router'
</script>

<style scoped>
.about {
  padding: 6rem 0;
  background: var(--color-background);
}

.container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 1rem;
}

.about-content {
  display: grid;
  grid-template-columns: 1.2fr 1fr;
  gap: 4rem;
  align-items: center;
}

.about-title {
  font-size: 2.5rem;
  font-weight: 700;
  margin: 0 0 1.5rem 0;
  color: var(--color-heading);
}

.about-description {
  font-size: 1.2rem;
  line-height: 1.6;
  color: var(--color-text);
  margin: 0 0 1.5rem 0;
}

.about-text p {
  font-size: 1.1rem;
  line-height: 1.6;
  color: var(--color-text);
  margin: 0 0 1.5rem 0;
}

.about-highlights {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 2rem;
  margin: 2rem 0;
}

.highlight {
  padding: 1.5rem;
  background: var(--color-background-soft);
  border-radius: 12px;
  border-left: 4px solid var(--color-primary);
  border-left-color: #f4c430;
}

.highlight h4 {
  font-size: 1.1rem;
  font-weight: 600;
  margin: 0 0 0.5rem 0;
  color: var(--color-heading);
}

.highlight p {
  font-size: 0.95rem;
  line-height: 1.5;
  color: var(--color-text);
  margin: 0;
}

.btn {
  display: inline-flex;
  align-items: center;
  padding: 1rem 2rem;
  border-radius: 8px;
  text-decoration: none;
  font-weight: 600;
  font-size: 1rem;
  transition: all 0.3s ease;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.btn-primary {
  background: linear-gradient(135deg, var(--color-primary) 0%, var(--color-secondary) 100%);
  color: white;
}

.btn-primary:hover {
  transform: translateY(-2px);
  box-shadow: 0 10px 30px rgba(244, 196, 48, 0.4);
}

.about-visual {
  display: flex;
  justify-content: center;
  align-items: center;
}

.visual-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-template-rows: 1fr 1fr;
  gap: 1rem;
  width: 100%;
  max-width: 400px;
}

.visual-item {
  border-radius: 16px;
  overflow: hidden;
}

.visual-large {
  grid-row: span 2;
}

.placeholder-image {
  background: linear-gradient(135deg, var(--color-primary) 0%, var(--color-secondary) 100%);
  padding: 2rem;
  text-align: center;
  color: white;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  min-height: 120px;
}

.visual-large .placeholder-image {
  min-height: 250px;
}

.visual-icon {
  font-size: 2rem;
  margin-bottom: 0.5rem;
  display: block;
}

.visual-large .visual-icon {
  font-size: 3rem;
  margin-bottom: 1rem;
}

.placeholder-image p {
  margin: 0;
  font-weight: 600;
  font-size: 0.9rem;
}

.visual-large .placeholder-image p {
  font-size: 1.1rem;
}

@media (max-width: 768px) {
  .about {
    padding: 4rem 0;
  }
  
  .about-content {
    grid-template-columns: 1fr;
    gap: 2rem;
  }
  
  .about-title {
    font-size: 2rem;
  }
  
  .about-highlights {
    grid-template-columns: 1fr;
    gap: 1rem;
  }
  
  .visual-grid {
    max-width: 300px;
  }
  
  .placeholder-image {
    padding: 1.5rem;
    min-height: 100px;
  }
  
  .visual-large .placeholder-image {
    min-height: 200px;
  }
}
</style>
